import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Form } from 'antd'

import useFetchData from 'Shared/Hooks/useFetchData'
import { showSuccess } from 'Shared/Components/NotifyToast'
import { TextInput, FormContainer } from 'Shared/Components/FormComponents'
import { apiUrl } from 'Shared/utils'

const WorkerForm = ({ mode, data, reloadData, closemodal }) => {
  const { setPageLoading } = useOutletContext()
  
  const { t } = useTranslation()
  const { send } = useFetchData()
  const [form] = Form.useForm()

  const onFinish = async (values) => {
    setPageLoading(true)

    const method = mode === "create" ? "POST" : mode === "edit" ? "PUT" : mode === "delete" ? "DELETE" : null
    const url = mode === "create" ? `${apiUrl}/common/workers` : `${apiUrl}/common/workers/${data["worker_id"]}`

    const res = await send({
      method: method,
      url: url,
      contentType: "json",
      body: {
        "firstname": values["firstname"],
        "lastname": values["lastname"],
        "company": values["company"],
        "title": values["title"]
      }
    })

    if (res != null) {
      closemodal()
      showSuccess(t("general_success"))

      await reloadData()
    }

    setPageLoading(false)
  }

  return (
    <FormContainer form={form} onFinish={onFinish} initialValues={["edit", "delete"].includes(mode) ? {
      "firstname": data["firstname"],
      "lastname": data["lastname"],
      "company": data["company"],
      "title": data["title"]
    } : {}}>
      <TextInput field_name={t("workers_workerFirstname")} field_id="firstname" required disabled={mode === "delete"}/>
      <TextInput field_name={t("workers_workerLastName")} field_id="lastname" disabled={mode === "delete"}/>
      <TextInput field_name={t("workers_company")} field_id="company" disabled={mode === "delete"}/>
      <TextInput field_name={t("workers_title")} field_id="title" disabled={mode === "delete"}/>
    </FormContainer>
  )
}

export default WorkerForm
